export default "__VITE_ASSET__D0Ix1IXs__"